import { WeightMetric } from './weight.metric';
import { WeightUSMetric } from './weight.us-metric';

/**
 * A mapping between a boards WeightMetric and its US customary units counterpart
 */
export const USWeightMetricTranslation: Record<WeightMetric, WeightUSMetric> = {
  [WeightMetric.Gram]: WeightUSMetric.GramUS,
  [WeightMetric.KiloGram]: WeightUSMetric.KiloGramUS,
  [WeightMetric.Tonne]: WeightUSMetric.TonneUS,
  [WeightMetric.KiloTonne]: WeightUSMetric.KiloTonneUS,
  [WeightMetric.GigaTonne]: WeightUSMetric.GigaTonneUS,
  [WeightMetric.MegaTonne]: WeightUSMetric.MegaTonneUS,
};

export const WeightMetricTranslation: Record<WeightUSMetric, WeightMetric> = {
  [WeightUSMetric.GramUS]: WeightMetric.Gram,
  [WeightUSMetric.KiloGramUS]: WeightMetric.KiloGram,
  [WeightUSMetric.TonneUS]: WeightMetric.Tonne,
  [WeightUSMetric.KiloTonneUS]: WeightMetric.KiloTonne,
  [WeightUSMetric.GigaTonneUS]: WeightMetric.GigaTonne,
  [WeightUSMetric.MegaTonneUS]: WeightMetric.MegaTonne,
};

export function getWeightMetricInMetricSystem(weightMetric: WeightMetric | WeightUSMetric): WeightMetric {
  if (weightMetric in WeightMetricTranslation) {
    return WeightMetricTranslation[weightMetric as WeightUSMetric];
  }
  return weightMetric as WeightMetric;
}
